import {GetItemCounts, useInfiniteNames} from "@twigsby/client-data";
import {
    ComboBoxControl, ContentBlock,
    ContentLoader,
    FormWrapperLabel,
    SelectItemType,
    useTranslation
} from "@twigsby/frontend-framework";
import {Controller} from "@twigsby/frontend-framework/lib/ReactHookForm";
import {useEffect, useState} from "react";
import {CustomComboBoxType} from "../../Types/FormTypes";

const NamesComboBox = (props: CustomComboBoxType) => {
    const { t } = useTranslation();

    const [ shapedData, setShapedData ] = useState<Array<SelectItemType>>([]);
    const [ itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 } );

    const {
        status,
        data,
        error,
        hasNextPage,
        fetchNextPage,
        isFetchingNextPage,
        dataUpdatedAt
    } = useInfiniteNames();

    const HandleReset = () => {
        if(props.resetSelectedCallback) {
            props.resetSelectedCallback()
        }
    }

    const ShapeData = () => {
        let selectOptions: Array<SelectItemType> = [];

        if(!data) return selectOptions;

        data.pages.map((page) =>
            page.data.map((name) => selectOptions.push({label: name.name, value: name.id}))
        )
        setShapedData(selectOptions);
    }

    useEffect(() => {
        if(data) {
            setItemCounts(GetItemCounts(data as any));
            ShapeData();
        }
    }, [dataUpdatedAt]);

    return (
        <>
            {status === 'loading' ? (
                <ContentLoader rounded={true} childCount={1} />
            ) : status === 'error' ? (
                <ContentBlock error={true} stacked={true} title={error.name} content={error.message} />
            ) : (
                <Controller
                    control={props.control}
                    name={props.name}
                    render={({ field, fieldState }) =>
                        <FormWrapperLabel
                            label={props.label || t('mailboxes.filter.labels.names')}
                            invalid={fieldState.invalid}
                            validationMessage={fieldState.error?.message}
                        >
                            <ComboBoxControl
                                data={shapedData}
                                valueType={'number'}
                                name={props.name}
                                placeholder={props.placeholder || t('mailboxes.filter.controls.namesStatusPlaceholder')}
                                loading={isFetchingNextPage}
                                forwardValuesCallback={(e) => {
                                    field.onChange(e);
                                    if(props.onChangeCallback) {
                                        props.onChangeCallback(e);
                                    }
                                }}
                                forwardItemCallback={(e) => {
                                    if(props.onChangeItemsCallback) {
                                        props.onChangeItemsCallback(e);
                                    }
                                }}
                                itemCounts={itemCounts}
                                hasNextPage={hasNextPage}
                                isFetchingNextPage={isFetchingNextPage}
                                fetchNextPage={fetchNextPage}
                                defaultValues={props.defaultValues ? props.defaultValues : undefined}
                                resetSelectedCallback={() => HandleReset()}
                            />
                        </FormWrapperLabel>
                    }
                />
            )}
        </>

    )
}

export { NamesComboBox }
